import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { atomicHub } from 'services/api';
import { Bitrix24Context } from 'contexts/legacy/Bitrix24Context';
import iconKory from 'assets/logos/icon-kory-half.png';

const CrossSellInsights: React.FC = () => {
	const intl = useIntl();
	const { getCurrentUserContext } = useContext(Bitrix24Context);

	const handleClick = async () => {
		const bx24 = (globalThis as Record<string, any>)['BX24'];
		const auth = bx24 ? bx24.getAuth() : { domain: 'solinka.bitrix24.com' };
		const domain = auth.domain;

		try {
			const user = await getCurrentUserContext(domain, auth.member_id);
			await atomicHub.post(
				'/cta-tracking/events',
				{
					eventType: 'click',
					componentType: 'banner',
					eventLocation: 'powerzap_insights',
					applicationSource: 'powerzap',
					userContext: user,
					abTestVariant: { variant: 'koral' },
					destinationUrl: `https://${domain}/market/detail/brs4.atomichat/?from=search&text=kory`,
					buttonText: intl.formatMessage({ id: 'cta_kory_insights_title' }),
				},
				{
					headers: {
						Authorization: `Bearer ${process.env.REACT_APP_ATOMIC_HUB_API_TOKEN}`,
					},
				},
			);
		} catch (error) {
			console.error('handleClick error', error);
		} finally {
			globalThis.open(
				`https://${domain}/market/detail/brs4.atomichat/?from=search&text=kory`,
				'_blank',
				'noopener,noreferrer',
			);
		}
	};

	return (
		<button
			onClick={handleClick}
			className="font-onest"
			style={{
				display: 'flex',
				flexDirection: 'row',
				width: '100%',
				margin: '5px 2px 2px 2px',
				padding: 'clamp(16px, 4vw, 28px)',
				borderRadius: 8,
				backgroundColor: '#ff6849',
				cursor: 'pointer',
				minHeight: 110,
				border: 'none',
				textAlign: 'left',
				overflow: 'hidden',
				position: 'relative',
			}}
		>
			<img
				src={iconKory}
				alt=""
				style={{
					position: 'absolute',
					bottom: -20,
					left: -55,
					height: 80,
					pointerEvents: 'none',
					zIndex: 1,
					objectFit: 'contain',
				}}
			/>

			<div
				style={{
					flex: 1,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-end',
					justifyContent: 'center',
					gap: 'clamp(6px, 1vw, 10px)',
					zIndex: 9,
					minWidth: 0,
				}}
			>
				<div
					style={{
						textAlign: 'right',
						fontSize: 'clamp(16px, 2vw, 24px)',
						lineHeight: 1.2,
						color: '#fffbfa',
						fontWeight: 500,
						whiteSpace: 'pre-line',
						wordBreak: 'break-word',
					}}
				>
					<FormattedMessage
						id="cta_kory_insights_title"
						values={{
							b: (chunks: React.ReactNode) => (
								<span
									style={{
										fontWeight: 600,
										color: '#131629',
									}}
								>
									{chunks}
								</span>
							),
						}}
					/>
				</div>
			</div>
		</button>
	);
};

export default CrossSellInsights;
